import { call, put, all, takeLatest, takeEvery } from "redux-saga/effects";
import * as api from "constants/api";

import {
  GET_EMPLOYEE_CATEGORIES,
  SG_GET_EMPLOYEE_CATEGORIES,
  DELETE_EMPLOYEE_CATEGORY,
  SG_DELETE_EMPLOYEE_CATEGORY,
  FETCH_EMPLOYEE_CATEGORY,
  SG_FETCH_EMPLOYEE_CATEGORY,
  EDIT_EMPLOYEE_CATEGORY,
  SG_EDIT_EMPLOYEE_CATEGORY,
  ADD_EMPLOYEE_CATEGORY,
  SG_ADD_EMPLOYEE_CATEGORY,
  CLEAR_EMPLOYEE_CATEGORY,
  ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";

function* loadmethods(action) {
  //   yield put({ type: GET_methodS_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_EMPLOYEE_CATEGORIES, action.payload);
    yield put({ type: GET_EMPLOYEE_CATEGORIES, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_EMPLOYEE_CATEGORIES, loadmethods);
}

function* fetchmethods(action) {
  try {
    const json = yield call(api.FETCH_EMPLOYEE_CATEGORY, action.payload);
    yield put({ type: FETCH_EMPLOYEE_CATEGORY, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_EMPLOYEE_CATEGORY, fetchmethods);
}

function* updatemethods(action) {
  try {
    const json = yield call(api.EDIT_EMPLOYEE_CATEGORY, action.payload);
    yield put({ type: EDIT_EMPLOYEE_CATEGORY, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeEvery(SG_EDIT_EMPLOYEE_CATEGORY, updatemethods);
}

function* addmethods(action) {
  try {
    const json = yield call(api.ADD_EMPLOYEE_CATEGORY, action.payload);       
    yield put({ type: ADD_EMPLOYEE_CATEGORY, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_EMPLOYEE_CATEGORY, addmethods);
}

function* deletemethods(action) {
  try {
    yield call(api.DELETE_EMPLOYEE_CATEGORY, action.payload);
    yield put({ type: DELETE_EMPLOYEE_CATEGORY, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_EMPLOYEE_CATEGORY, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
